// core/items/ItemsController.ts
// Нормализация в массив 
function toArray(v) { return Array.isArray(v) ? v : [v]; }

export { toArray };
